<template>
    <div style="display: flex;
    justify-content: center;">
        <v-card class="elevation-2 mt-12">
            <v-card-title>
                For security reason, please change your password.
            </v-card-title>
            <v-card-text>
                <v-alert
                    type="info"
                >
                    Password must contain one lowercase, one uppercase, one special character and greater than 6 digit
                </v-alert>
                <v-form ref="firstPasswordRef">

                    <v-text-field
                        :rules="[rules.required, rules.password]"
                        :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                        :error-messages="newPasswordErrors"
                        :type="passwordShow ? 'text' : 'password'"
                        @click:append="passwordShow = !passwordShow"
                        label="Password"
                        outlined
                        prepend-inner-icon="fingerprint"
                        v-model="formData.password"
                        @input="newPasswordErrors=[]"
                    />
                    <v-text-field
                        :rules="[rules.required]"
                        :append-icon="confirmPasswordShow ? 'visibility_off' : 'visibility'"
                        :error-messages="confirmPasswordErrors"
                        :type="confirmPasswordShow ? 'text' : 'password'"
                        @click:append="confirmPasswordShow = !confirmPasswordShow"
                        label="Confirm Password"
                        outlined
                        prepend-inner-icon="fingerprint"
                        v-model="formData.password_confirmation"
                        @input="confirmPasswordErrors=[]"
                    />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    :loading="loading"
                    @click="createNewPassword"
                    class="white--text "
                    color="blue darken-3"
                >Change
                </v-btn>
            </v-card-actions>
        </v-card>

    </div>


</template>

<script>
    import {validationMixin} from "../../../mixins/validationMixin";
    import {VERSIONED_API_URL} from "../../../config/config";
    import Http from "axios"

    export default {
        name: "PasswordFirstChange",
        data() {
            return {
                formData: {},
                passwordShow: false,
                confirmPasswordShow: false,
                passwordShowOld: false,
                oldPasswordErrors: [],
                newPasswordErrors: [],
                confirmPasswordErrors: [],
                loading: false,
            }
        },
        mixins: [validationMixin],
        methods: {
            async createNewPassword() {
                if (this.$refs.firstPasswordRef.validate()) {
                    try {
                        const {data} = await Http.post(`${VERSIONED_API_URL}/password-change-new`, {
                            password: this.formData.password,
                            password_confirmation: this.formData.password_confirmation
                        });
                        this.$store.commit('Notification/showSuccess', data.message);
                        this.$store.commit('AuthUser/setPasswordChangeRequired', 0)
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        }
    }
</script>
